export default {
  pim: "PIM",
  Root: {
    Basic: {
      Failed: "失败",
      Result: "结果",
      Success: "成功",
      Select: "选择",
      Cancel: "取消",
      Confirm: "确定",
      Ok: "好",
      Tips: "提示",
      Warning: "警告",
      Method: "方法",
      Required: "必填项",
      MaxLength: "长度限制在{num}字符以内",
      Submit: "提交",
      Search: "搜索",
      Reset: "重置",
      More: "更多"
    },
    Layout: {
      Expand_the_sider_menu: "展开菜单栏",
      Collapse_the_sider_menu: "收起菜单栏",
      please_select: "请选择",
      Change_Password: "重置密码",
      Log_out: "登出",
      My_Applications: "我的应用",
      salesChannels: "销售渠道",
      search_org: "搜索组织名称",
      search_2_org: "搜索二级组织名称"
    },
    Import: {
      Job: "任务",
      No: "编号",
      row_of_sheet: "所在行",
      reason_of_fails: "失败的原因",
      File: "文件",
      no_data: "没有数据",
      import: "导入",
      upload: "上传",
      refresh: "刷新",
      refresh_notice: "单击“刷新”以查看最新状态",
      view_result: "查看结果",
      Started_at: "开始于",
      Status: "状态",
      total_count: "总数",
      error_count: "错误总数",
      Action: "操作",
      got_it: "我知道了",
      execution_history: "执行历史",
      import_history: "导入历史",
      download_template: "下载模板",
      job_description: "任务描述",
      import_products: "导入商品",
      import_completed_at: "导入完成于",
      importing: "导入中，烦请耐心等待片刻，导入结果将会展示在执行历史列表中。",
      import_products_desc:
        "你可以将商品信息导入到PIM系统中，在操作之前，我们建议你首先下载导入数据的模板以供参考。",
      select_a_file: "请先选择一个文件",
      Please_select_an_org: "请先选择一个组织",
      rules_title: "导入规则",
      import_run_tip: "当导入运行时，您无法查看结果。",
      Please_confirm_the_org: "请确认向需要的组织导入",
      Confirme_or_switch_org: "确认或切换组织",
      Import_Products: "导入产品",
      Import_SKU: "导入SKU",
      Import_Price: "导入价格",
      Import_Image: "导入图片",
      Import_Channel_Info: "导入渠道信息",
      DownloadTemplate: "下载源文件"
    },
    Picker: {
      ByCondition: "根据条件",
      Byproduct: "根据商品",
      BySKU: "根据规格SKU",
      Sku_code_sku_name: "SKU名称/SKU",
      Enter_sku_to_search: "通过SKU或商品编码搜索",
      ORG: "组织",
      Find_product_throung_search: "搜索并加入商品",
      Required: "必要的",
      Select_ORG: "组织",
      Condition_products: "条件商品",
      Please_select_at_least_options: "请至少选择一个选项",
      Download_Template: "下载模板",
      Select_a_file: "选择文件",
      Will_overwrite_the_p: "此操作为覆盖之前导入的数据。确定要继续吗?",
      Attributes: "属性",
      skuAttributes: "SKU属性",
      spuAttributes: "商品属性",
      Only_select_attribut: "仅选择型的属性可以作为筛选条件",
      Only_select_up_to_th: "最多选择{max}项属性",
      Add_attribute: "添加属性",
      Please_select_at_least_attribute: "请至少选择一个属性值",
      Manual: "自选",
      Import: "导入",
      Selected_items: "已选 ({total})",
      Enter_product_name_to_search: "输入商品名称或商品编码搜索",
      Product_code: "商品编码",
      Product_name: "商品名称",
      You_can_select_produ: "使用Excel文件选择商品。建议下载模板后填写。",
      Imported_Products: "已导入的商品",
      Enter_SKU_code_to_search: "输入SKU编码搜索",
      Sku_name: "SKU名称",
      Sku_code: "SKU编码",
      You_can_select_SKU_f: "使用Excel文件选择规格SKU。建议下载模板后填写。",
      Imported_Skus: "已导入的SKU",
      Select: "选择",
      Select_all_products: "选择全部商品",
      Select_attribute: "选择属性",
      Upload: "上传",
      Cancel: "取消",
      Yes: "是",
      Categories: "类目",
      Brands: "品牌",
      EmptyFile: "文件为空",
      ByTags: "根据标签",
      Method: "选择来源",
      ByMobile: "根据手机",
      ByUserID: "根据用户ID",
      Repeat: "重复项",
      upload_xlsx_err: "请上传正确的表格数据!"
    },
    Export: {
      export: "导出",
      export_all: "导出全部",
      history: "导出历史",
      time: "导出时间",
      requester: "请求者",
      language: "语言",
      status: "状态",
      action: "操作",
      no_history: "暂无历史记录",
      choose_language: "选择语言",
      loading: "加载中...",
      download: "下载",
      refresh_notice: "单击“刷新”以查看最新状态",
      page_notice: "将商品、属性或其他信息导出到本地文件",
      exporting: "正在准备要下载的商品数据...",
      refresh: "刷新",
      export_all_notice:
        "确定要导出全部商品吗？商品数量众多时此操作可能较为耗时。"
    },
    MemberPicker: {
      required: "必填项",
      Enter_user_id_separated_by: "输入用户ID，以‘,’分隔",
      Enter_mobile_separated_by: "输入手机号码，以‘,’分隔",
      Search_tag: "输入标签名称进行搜索",
      selected_members: "选择成员"
    },
    TimeLine: {
      OperationLog: "操作日志",
      View_More: "查看更多",
      Callpase: "折叠",
      No_Data: "暂无数据"
    },
    Clipboard: {
      Success: "复制成功：{content}",
      ToCopy: "点击以复制"
    },

    Upload: {
      select_tip: "请选择文件!"
    },
    HeaderSearchStore: {
      Switch_Org: "切换组织",
      All_Stores: "所有店铺",
      Online_Store: "线上店铺",
      Offline_Store: "线下店铺"
    }
  },
  Brand: {
    brand: "品牌",
    Brand_Name: "品牌名称",
    Brand_Code: "品牌代码",
    Brand_Logo: "品牌图标",
    confirm_delete_brand_warning: "确定要删除吗？",
    search_brand_placeholder: "输入品牌名称以搜索",
    input_brand_name: "请输入品牌名称"
  },
  Category: {
    create_root_category: "创建根节点",
    category_name: "分类名称",
    category: "类别",
    category_code: "类别代码",
    category_delete: "此操作会删除该类别及其子类别。确定要删除吗？",
    input_category_name: "请输入类别名称",
    category_Logo: "类别图标"
  },
  Product: {
    product_name: "商品名称",
    product_status: "商品状态",
    search_product_placeholder: "请输入商品名称",
    add_sku: "添加Sku",
    add_attr: "添加attribute",
    price: "吊牌价",
    sale_price: "零售价",
    media: "Media",
    sku: "SKU",
    properties: "Properties",
    attributes: "商品属性",
    description: "商品描述",
    product: "商品",
    list_price: "市场价",
    mb_media: "移动端图片视频",
    sku_status: "SKU状态",
    deactivate: "下架",
    activate: "上架",
    inactive: "下架",
    media_des: "图片视频",
    mb_media_des: "移动端图片视频",
    pictures: "图片",
    required_20_char_num_let: "必须是1-20位长的字母或数字",
    required_50_char_num_let: "必须是1-50位长的字母或数字",
    channel: "渠道",
    region_code: "区域代码",
    external_code: "外部对接编码",
    system_auto_creatd_unique_across_org: "系统自动创建的唯一标识码",
    user_created_unique_within_org: "用户自定义编码且组织内唯一",
    code_used_in_user_own_system: "用户系统内(如ERP等)的商品编码",
    list_product: "您是否需要上架此商品？",
    product_code: "商品编码",
    product_number: "商品自定义编码",
    brand: "品牌",
    categories: "类别",
    onboard_time: "商品上架时间",
    create_time: "商品创建时间",
    barcode: "条型码",
    viewChannel: "查看渠道SKU编码",
    Channel: "渠道",
    Channel_sku_code: "渠道SKU编码",
    require: "必填",
    selected: "已选",
    image: "图片",
    sort: "排序值",
    delivery_product: "普通商品",
    service_product: "服务商品",
    virtual_product: "虚拟商品",
    sku_code: "SKU编码",
    sku_number: "SKU自定义编码",
    sku_name: "SKU名称",
    sku_media: "SKU图片视频",
    sku_empty: "请至少添加一个SKU",
    sku_duplicate: "SKU自定义编码重复",
    type: "商品类型",
    shopName: "店铺名",
    export: "导出",
    success_export: "导出请求已经成功提交",
    export_notice_title: "导出商品",
    export_submitted: "导出后, 请到导出列表查看导出状态，及下载数据文件。",
    export_all: "你正在请求导出商品",
    export_filter: "你正在请求导出筛选后的商品",
    view_export: "查看导出状态",
    synchronous_price: "是否希望将此商品价格更新到其所有SKU？",
    sku_save_info:
      "您已经修改了SKU信息，需要点击“保存SKU”按钮才能生效。但如果您修改SKU状态，它将立即生效。",
    publish_submited: "发布已提交",
    view_result: "查看结果",
    batch_empty: "请选择商品",
    batch_active_notice: "你确定要上架这些商品吗?",
    batch_deactive_notice: "你确定要下架这些商品吗?",
    no_active: "所选商品均已上架，不需要重复操作",
    no_deactive: "所选商品均已下架，不需要重复操作",
    batch_num: "总共选择了{num}个商品 "
  },
  Attribute: {
    attribute: "属性",
    attribute_name: "属性名",
    search_attr_placeholder: "输入属性名以搜索",
    value_type: "属性值类型",
    add_attribute: "添加属性",
    code: "属性编码",
    type: "属性类型",
    generate_sku: "用于标识SKU",
    is_Required: "必填属性",
    is_per_channel: "支持多渠道",
    is_per_locale: "支持多语言",
    is_front_display: "商城端展示",
    is_front_filterable: "可用于筛选",
    image: "图片",
    option: "选项值",
    value_type_title: "值类型",
    add_option: "添加选项值",
    edit_Languages: "编辑",
    edit_Languages_2: "编辑多语言",
    option_placeholder: "请编辑多语言",
    delete_option: "删除选项值",
    is_multi_language: "支持多语言",
    product: "商品",
    Single_Select: "单选",
    Multiple_Select: "多选",
    Number: "数字",
    Text: "文本",
    Text_Area: "文本域"
  },
  Basic: {
    Failed: "失败",
    Success: "成功",
    Result: "结果",
    Select: "选择",
    Cancel: "取消",
    Confirm: "确定",
    OK: "好",
    Ok: "好",
    Tips: "提示",
    Warning: "警告",
    Method: "方法",
    Required: "必填项",
    MaxLength: "长度限制在{num}字符以内",
    Submit: "提交",
    Search: "搜索",
    Reset: "重置",
    More: "更多",
    DefaultShow3Mounth: "默认展示最近3个月的订单",
    InventorySyncLog: "库存同步日志",
    Ext_SKU: "品牌SKU编码",
    Order_Shipment: "订单发货",
    Complete_Order: "完成订单",
    Email: "邮箱",
    Member_Email: "会员邮箱",
    "External_Order_#": "外部订单号",
    Order_Source: "订单来源",
    Point_Amount: "积分金额",
    Total_Amount: "总金额",
    Optarion_Log: "操作日志",
    Logistic_Company: "物流公司",
    R_sure_to_submit: "您确定要提交此更改吗?",
    Yes: "是",
    No: "否",
    Sure: "确认",
    Continue: "跳过",
    Fail: "失败",
    Reason: "原因",
    On_Hold: "是否挂起",
    You_have_num_package: "你有{num}个包裹",
    No_package: "没有包裹",
    Package: "包裹",
    Payment_Channel: "支付渠道",
    Hold_Reason: "挂起原因",
    ChannelInventory: "渠道库存",
    DOAddressRouting: "DO路由区域仓配置",
    O2OMapping: "O2O绑定关系",
    FullStock: "存货导入",
    Subtotal: "商品总金额",
    Total_Discount: "总折扣",
    Order_Promotions: "促销信息",
    Promotions: "促销活动",
    Update_Error: "{X}更新错误",
    Please_enter_SKU_Code: "请输入SKU编码",
    Package_Items: "包裹明细",
    OrderNo: "订单号",
    NodeInventory: "存货库存",
    Arey_sure_to_deliver: "您确认已收货吗?",
    OrderFulfillmentRules: "订单履约规则",
    ProductNum: "无商品 | 1件商品 | {count}件商品",
    Order_Details: "订单详情",
    Do_NO: "DO编码 {code}",
    Create_Time_at: "创建于{date}",
    Change_Number: "无变动 | 1次变动 | {count}次变动",
    OrderStatusChanges: "订单状态从{pre}变更至{curr}",
    WMSOutboundNode: "出库仓",
    WMSOutboundTime: "出库时间",
    Routed_Node: "路由仓",
    TrackingNo: "物流单号",
    AUSureCancelDO: "您确认要取消DO单吗？",
    Task_List: "待办事项",
    invoice_info: "发票信息",
    "Company_Tax_#": "企业纳税人识别号",
    Invoicing_Title_Type: "发票抬头类型",
    Invoicing_Title: "发票抬头",
    Is_Need_Invoice: "是否需要发票",
    Unpaid_Orders: "未付款",
    Pending_Orders: "待发货",
    Pending_Audit_Return: "待审核退货",
    Pending_Audit_Refund_Result: "待财务审核退款",
    Wating_Orders: "待接单",
    Wating_for_Reply: "待回复",
    Routing_Failed: "路由失败",
    Order_Picking: "配货中",
    Pending_Complete_Refund: "待完成退款",
    Picking_Failed: "配货失败",
    Waiting_Inbound: "待退货入库",
    Pending_Audit_Refund: "待审核退款",
    Limit90days: "每次搜索的时间跨度限制在90天内，请重新选择起止日期",
    Fulfillment: "履约管理",
    Orders: "订单管理",
    By_Online_Stores: "线上店维度",
    By_Node: "仓库维度",
    EditReturn: "编辑退货单",
    ReturnNo: "退货单编号 {no}",
    ReturnAmount: "退货总金额",
    ReturnInfo: "退货",
    ChannelReturnRequest: "渠道退货申请",
    ChannelSKUCode: "渠道SKU编号",
    SubOrderNo: "子订单编号",
    ReturnQTY: "退货数量",
    ShippingNo: "物流单号",
    OrderStatusIs: "当前订单状态为{status}",
    PayStatus: "支付状态",
    Unpaied: "未支付",
    Paied: "已支付",
    OnlineRefund: "线上退款",
    OfflineRefund: "线下退款",
    MaxTips: "最多可以申请退款的金额为{amount}",
    OnlinePayMethod: "{label}（线下）",
    Desc1: "退款金额默认=商品金额，退款金额不能超过实际支付的金额。",
    Desc2: "可退款金额 = 实际支付的金额 - 已退款的金额",
    Desc3: "当整单退款<br />退款金额 = 商品金额 + 运费",
    Desc4: "退款金额 = 商品金额",
    Desc5: "可退运费 = 订单运费-已退款的运费",
    Please_enter_1_1000_order_no: "请输入1/1000个订单号,例如1,2,3",
    Action: "操作",
    Create: "创建",
    Edit: "编辑",
    Delete: "删除",
    no_empty: "不能为空",
    Next: "下一步",
    Save: "保存",
    please_select: "请选择",
    Add: "添加",
    Status: "状态",
    Create_Order: "Create Order",
    Store_No: "仓库编码",
    Please_select_product: "请选择一个商品",
    Please_add_payment_method: "请添加一个支付方式",
    Node: "仓库",
    Channel_Order_No: "渠道订单号",
    Mobile_No: "手机",
    Telephone_No: "电话",
    Order: "订单",
    Create_Time: "创建时间",
    Sync_Time: "同步时间",
    Error_Msg: "错误信息",
    After_Sync_Qty: "同步后数量",
    Sync_Qty: "同步数量",
    External_SKU_Code: "品牌SKU编码",
    Sync_Status: "同步状态",
    Sync_Type: "同步类型",
    Price: "折前单价",
    Payment_Type: "支付类型",
    Inventory_Log: "库存同步日志",
    Safety_Inventory_Qty: "安全库存数量",
    Invoice_Header_Type: "发票抬头类型",
    Invoicing_Method: "开票方式",
    Personal: "个人",
    Company: "公司",
    Invoice_Header: "发票抬头",
    Company_Tax_No: "企业税号",
    Payment_No: "支付流水",
    Bank_Account: "银行账户",
    Electronic: "电子",
    Paper: "纸质",
    Payment_Info: "支付信息",
    Bank: "银行",
    Invoice: "发票",
    Add_Payment: "支付信息",
    Payment_Account: "支付账户",
    Shipping_Info: "配送信息",
    R_sure_to_complete: "您确认要完成这个售后单？",
    Reminder: "提醒",
    Return_Application_No: "售后申请单号",
    Refund_Application_No: "售后申请单号",
    Return_Application_Status: "状态",
    Return_Application: "售后申请",
    Complete_Time: "完成时间",
    Return_Complete: "售后完成时间",
    Please_enter_node_code_name: "请选择一个仓库",
    Node_Code: "仓库编码",
    Order_Type: "订单类型",
    Delivery_Info: "配送信息",
    Online_Store_Name: "店铺名称",
    Create_Channel_Order: "创建订单",
    Please_recheck_the_form: "请重新检查表格",
    Only_display_results_from_selected_store: "选择门店商品",
    Application: "申请",
    App_Name: "应用名称",
    Choose_Member: "选择会员",
    Choose_Store: "选择仓库",
    Transition: "交易",
    Member_Code: "会员编码",
    Member_Name: "会员名称",
    Mobile: "手机",
    Add_Product: "添加商品",
    Total_Price: "折前总价",
    Sale_Price: "折后单价",
    Product: "商品",
    Discount: "折扣",
    Discount_Losses: "折损",
    Amount: "金额",
    Service_Store: "服务门店",
    Choose_member: "选择会员",
    Select_products: "选择商品",
    Export: "导出",
    Active: "启用",
    Inactive: "禁用",
    Activate: "启用",
    Deactivate: "禁用",
    confirm_delete: "您确认要删除?",
    create_time: "创建时间",
    create_user: "创建人",
    return: "售后",
    View: "查看",
    promotion: "促销 | 促销",
    deduction: "折扣",
    product_items: "商品明细",
    price: "折前单价",
    sale_price: "折后单价",
    qty: "数量",
    amount: "金额",
    payment: "支付",
    Payment_method: "支付方式",
    Payment_Method: "支付方式",
    Time: "时间",
    customer_code: "会员编码",
    Name: "收件人",
    resv_time: "预约时间",
    order_amount: "订单金额",
    return_amount: "售后金额",
    store_name: "仓库名称",
    store: "仓库",
    created_from: "创建时间从",
    created_to: "创建时间至",
    status: "状态",
    customer: "客户",
    plate: "车牌号",
    source: "子类型",
    payment_type: "支付类型",
    basic_info: "基础信息",
    payment_info: "支付信息",
    customer_info: "收件人信息",
    order_promotion: "促销信息",
    order_items: "订单明细",
    Refund: "退款",
    refund: "退款单号",
    return_no: "售后申请单号",
    items_to_refund: "退款明细",
    change_log: "操作日志",
    change: "变更",
    User: "创建人",
    date_and_time: "创建时间",
    refund_request_info: "退款结果信息",
    cancel: "取消",
    sure: "确认",
    title: "标题",
    type_store_name_or_code: "请使用仓库编码和名称查询",
    create_to: "创建时间从",
    detail: "明细",
    approve: "审批通过",
    reject: "审批拒绝",
    payment_no: "支付流水号",
    refund_detail: "退款明细",
    return_detail: "售后信息",
    return_request_info: "售后申请信息",
    items_to_return: "售后明细",
    are_you_certain_to_cancel_the_order: "您确认要取消订单?",
    Shop_Discount: "店铺折扣",
    Type_the_reason_for_cancel: "取消原因",
    Complete: "完成",
    Sure_message: "您确认要创建?",
    account: "账户",
    time: "时间",
    refund_amount: "退款金额",
    amount_discount: "折扣金额",
    refund_apply_type: "退款申请类型",
    bank: "银行",
    bank_account: "银行账户",
    Remark: "备注",
    Save_and_submit: "保存并提交",
    Enter_order_code: "输入订单号",
    Enter_channel_order_code: "输入渠道订单号",
    Order_code_is_required: "订单号是必输的",
    Channel_order_code_is_required: "渠道订单号是必输的",
    Submit_again: "开始提交",
    type_reason_of_reject: "拒绝原因",
    Complete_time: "完成时间",
    payment_account: "支付账户",
    Transaction_Fee: "手续费",
    Telphone: "电话",
    "Telphone_#": "电话",
    Zipcode: "邮编",
    Post_Code: "邮编",
    Region: "地区",
    Address: "地址",
    Adress: "地址",
    Carrier: "物流商",
    Shipping_Number: "快递单号",
    Country: "国家",
    Province: "省",
    City: "市",
    District: "区",
    Area: "区域",
    Product_code: "商品编码",
    Bar_code: "条码",
    "SKU_#": "SKU编码",
    SKU: "SKU",
    SKU_Item: "SKU明细",
    SKU_Name: "SKU 名称",
    Sub_order_number: "渠道子订单号",
    Deduction_amount: "折扣金额",
    Activity_code: "活动编码",
    Discount_type: "折扣类型",
    Deduction_code: "活动编码",
    "Order_#": "订单号",
    Order_Status: "订单号状态",
    "Channel_Order_#": "渠道订单号",
    "WMS_#": "WMS单号",
    Shop_Name: "店铺名称",
    Channel: "渠道",
    Routed_Node_Name: "路由仓库",
    Node_Name: "仓库名称",
    "Mobile_#": "手机",
    SKU_Code: "SKU 编码",
    Barcode: "条码",
    Brand_SKU_Code: "品牌SKU编码",
    Seller_SKU: "品牌SKU",
    Seller_SKU_Code: "品牌SKU编码",
    "Member_#": "会员编码",
    Channel_SKU_Code: "渠道SKU编码",
    "Channel_Sub_Order_#": "渠道子订单号",
    Org_not_empty_tips: "请选择一个组织",
    ShopName_not_empty_tips: "请选择一个店铺名称",
    Online_Stores_Name: "店铺名称",
    Are_you_sure_you_want_to_delete: "您确认想要删除?",
    Total_Qty: "总数量",
    Delivery_Type: "配送类型",
    Import: "导入",
    External_Code: "外部编码",
    Promotion_Amount: "折扣金额",
    Coupon: "优惠卷",
    Shipping_Fee: "运费",
    Handing_Charge: "手续费",
    required_num_msg: "请输入一个数字",
    required_num_0: "必须大于0",
    Customer_Account: "客户账户",
    Rejected_Reason: "拒绝原因",
    Payee: "收款人",
    Channel_Node: "渠道仓库",
    hours: "小时",
    Tax: "税费",
    Start_Date: "开始日期",
    End_Date: "结束日期",
    Create_Order_Fail: "创单失败",
    Failure_Type: "失败类型",
    Order_Info: "订单信息",
    Are_you_sure_want_to_receive_this_order: "您确认要接单？",
    Are_you_sure_want_to_cancel_this_order: "您确认要取消订单？",
    Please_enter_0_to_500_characters: "请输入0/500字符",
    Please_enter_an_integer_greater_than_or_equal_to_1: "请输入大于等于1的整数",
    // 以下未翻译
    Refund_Info: "退款信息",
    Refund_History: "历史退款单据",
    Channel_Refund_Application: "渠道售后申请",
    Channel_Return_Application: "渠道售后申请",
    Refundable_Amount: "可退金额",
    Refund_Type: "退款类型",
    Create_refund: "创建退款",
    Change_Log: "变更日志",
    Refund_Method: "退款方式",
    Online: "线上",
    Offline: "线下",
    The_refund_amount_cannot_be_gr: "请检查退款金额，退款金额不能大于可退金额",
    Maximum_refundable_amount: "最大可退金额: {amount}",
    Refund_Amount: "退款金额",
    Payee_Account: "收款人账户",
    Attachment: "附件",
    Attachments: "附件",
    The_refund_amount_must_be_equa: "退款金额需要等于退款方式金额总和",
    Only_5_files_size_less: "仅能上传5个图片，图片需要小于{size}",
    Products_Count: "{count}件商品",
    Create_Refund: "创建退款",
    Edit_Refund: "修改退款",
    Audit_Refund: "审批退款",
    Refund_Details: "退款明细",
    Channel_Order_No2: "渠道订单号{id}",
    Refund_No: "退款单号{id}",
    Member_Code_no: "会员编码: {value}",
    Create_Time_by: "创建时间: {value}",
    Fail_to_Fulfill: "未发货退款",
    Return: "退货",
    Product_Items: "商品明细",
    Refund_Number: "退款单号",
    Qty: "数量",
    Online_Shop_Name: "线上店名称",
    Back: "返回",
    Choose_Order: "选择单据",
    Cannot_be_0: "退款金额需要>0",
    Refund_Apply_No: "售后申请单号",
    Refund_Reason: "退款原因",
    Changes: "{count}次变更",
    No_changes: "没有变更",
    Product_Code: "商品编码",
    products_Count: "{count}件商品",
    Items_of_Refund: "退款明细",
    Audit: "审批",
    Are_you_sure_to_cancel: "您确认要取消退款单吗?",
    Are_you_sure_to_approve: "您确认要审批通过这个退款吗?",
    Reject: "拒绝",
    Approve: "审批",
    Transfer_Vouchers: "转账凭证",
    Cancel_Refund: "取消退款",
    Reason_Rejection: "拒绝原因",
    Only_5_files_can_uploaded: "仅支持上传5个以内小于{size}的jpg / png文件",
    failed: "失败",
    fail: "失败",
    image: "图片",
    type: "类型",
    logo: "图标",
    Switch: "切换",
    tenant: "租户",
    org: "组织",
    prev: "上一个",
    required_msg: "必填",
    required_20_char: "不能超过20字符",
    required_50_char: "不能超过50字符",
    required_100_char: "不能超过100字符",
    required_500_char: "不能超过500字符",
    required_1000_char: "不能超过1000字符",
    required_number_letter_dashes: "只允许字母、数字及横线",
    num_be_init: "排序必须是整数",
    reset: "重置",
    ok: "好",
    more: "更多",
    yes: "是",
    no: "否"
  },
  Refund: {
    Refund: "退款",
    Reminder: "提醒",
    Create_refund: "创建退款",
    Return_Details: "售后申请信息",
    Create_Return_Application: "创建售后申请",
    refund: "退款单号",
    return: "售后申请单号",
    items_to_refund: "退款明细",
    change_log: "变更日志",
    change: "变更",
    User: "创建人",
    Return_Reason: "退货原因",
    Refund_Result: "退款结果",
    date_and_time: "时间",
    "return_request_#": "退款结果编码",
    refund_request_info: "退款结果信息",
    can_be_create_refund: "不能创建退款，订单未支付或已取消",
    after_complete: "订单已完成，不能编辑",
    refund_remark: "退款备注",
    payee_bank: "收款银行",
    payee_account: "收款账户",
    Payment_Amount: "收款金额",
    financial_refund_type: "退款方式",
    bankmethod_empry_msg: "收款方式不能为空",
    bankaccount_empry_msg: "收款账户不能为空",
    refundamount_empry_msg: "退款金额不能为空且需>0",
    transfer_voucher: "转账凭证",
    Voucher: "凭证",
    Confirm_In_Bound: "确认收货",
    Please_confirm_submit_refund_order: "您确认要提交这个退款单？",
    Are_you_sure_you_want_to_complete_the_return: "您确认要完成这个退款单？",
    The_order_status_is_created_cancelled_unpaid_cannot_create_a_refund:
      "订单未支付或已取消无法创建退款",
    Inbound: "入库",
    Return_Request_No: "退货申请编码",
    Return_Request_Details: "退货申请详情",
    Refund_Request_Inbounded_Tips: "您确定此订单已入库?"
  },
  Pricing: {
    pricing: "高级价格设置",
    add_price: "新建价格",
    Level_One: "维度1",
    Level_Two: "维度2",
    delete_tips_msg:
      "该页面有未保存的数据，刷新页面会导致数据丢失，确定要继续吗？",
    code: "code:",
    miss_sku_code: "缺少SKU编码",
    input_level_one: "请输入维度1",
    input_salePrice: "请输入销售价格",
    miss_price_code: "缺少价格编码",
    batch_shelves: "批量上架",
    batch_active_notice:
      "请先确定你已保存需要的数据,你确定要批量上架这些商品价格吗？",
    batch_deactive_notice:
      "请先确定你已保存需要的数据,你确定要批量下架这些商品价格吗？",
    batch_empty: "请选择价格",
    batch_off_shelves: "批量下架",
    no_active: "所选价格均已上架，不需要重复操作",
    no_deactive: "所选价格均已下架，不需要重复操作"
  },
  O2OOrder: {
    Order: "订单",
    order: "订单",
    Store: "门店",
    "Store_#": "仓库编码",
    Channel_Order: "全渠道订单",
    "Channel_Order_#": "渠道订单号",
    Channel_order_details: "渠道订单明细",
    Service_order: "服务订单",
    Create_service_order: "新建服务订单",
    store_name: "仓库名称",
    Shop_name: "店铺名称",
    created_from: "创建时间从",
    created_to: "创建时间至",
    Fulfill_status: "状态",
    status: "状态",
    customer: "收件人",
    plate: "手机号",
    source: "子类型",
    amount: "金额",
    payment_type: "支付类型",
    basic_info: "基础信息",
    payment_info: "支付信息",
    customer_info: "配送信息",
    order_promotion: "促销信息",
    order_items: "订单明细",
    Store_code: "门店编码",
    Channel: "渠道",
    payment_account: "支付账户",
    Order_discount: "折扣",
    Order_details: "订单明细",
    Service_Order_details: "服务订单明细",
    Refund_details: "退款明细",
    Refund_Type: "退款类型",
    Refund_Apply_Type: "退款类型",
    Bank_name: "银行名称",
    Bank_account: "银行账户",
    Refund_amount: "退款金额",
    Basic_info: "基础信息",
    Order_status: "订单状态",
    Payment_account: "支付账户",
    Coupon_amount: "优惠卷",
    Payment_status: "支付状态",
    Cancel_reason: "取消原因",
    Seller_notes: "卖家备注",
    Buyer_notes: "买家备注",
    Service_order_change_log: "订单状态从",
    Order_change_log: "订单状态从",
    To: "到",
    Order_success: "操作成功",
    Service_order_success: "操作成功",
    Create_service_order_success: "创单成功",
    Create_order_success: "创单成功y",
    Create_delivery_order_success: "创单成功",
    Create_return_order_success: "创单成功",
    Carrier: "物流商",
    "Tracking_#": "快递单号",
    Ship_order: "发货",
    Shipped: "已发货",
    Delivered: "已签收",
    Delivery_Failed: "配送失败",
    Ready_to_Ship: "准备发货",
    Enter_ship_number: "请输入快递单号",
    Order_is_canceled: "订单已取消!",
    Enter_reason: "请输入原因",
    Enter_seller_notes: "请输入卖家备注",
    Sub_type: "子类型",
    Paymt_type: "支付类型",
    Order_type: "订单类型",
    Freight: "运费",
    Confirm_Payment: "确认支付",
    Receive_Order: "接单",
    Shipping_number_and_carrier__carrier_cannote_be_empty:
      "物流商和快递单号不能为空",
    Delivery_information_cannot_be_empty: "配送信息不能为空",
    Status_order_successfully: "{status} 订单成功。",
    Status_service_order_successfully: "{status} 服务单成功。",
    Status_delivery_order_successfully: "{status} 发货单成功。",
    Status_return_order_successfully: "{status} 退货单成功。",
    Order_change_log_status: "订单状态从 {exStatus} 到 {status}.",
    Service_change_log_status: "服务单状态从 {exStatus} 到 {status}.",
    Delivery_change_log_status: "发货单状态从 {exStatus} 到 {status}.",
    Return_change_log_status: "退货单状态从 {exStatus} 到 {status}."
  },
  "20200813": {
    Product: {
      create_product: "新建商品",
      create_step1: "步骤1: 新建商品",
      create_step2: "步骤2: 新建SKU",
      basic_info: "基本信息",
      basic_note: "点击图标“{icon}“以编辑多语言信息",
      no_attribute: "没有设置属性",
      media_info: "图片视频尺寸不能大于1M",
      next_step: "下一步",
      SKU_nfo: "SKU信息",
      Availability: "可用性",
      pc_media: "PC媒体",
      choose_family: "使用品类快速创建商品",
      family_select: "商品品类",
      skip: "跳过",
      multiInfo: "多语言",
      delete_info: "SKU下架后可以被删除",
      SKU_media: "SKU媒体",
      previous: "前一个",
      save_product: "保存商品",
      save_SKU: "保存SKU",
      edit_product: "编辑商品",
      copy_code: "复制编码",
      copy_success: "复制成功",
      empty_sku: "至少添加一个SKU",
      activated: "已上架",
      deactivated: "已下架",
      edit_SKU: "编辑SKU"
    }
  },
  DO: {
    DO: "DO",
    Delivery_Order: "发货单",
    Delivery_Order_Details: "发货单详情",
    "DO_#": "发货单号",
    DO_Status: "状态",
    DO_Type: "DO 类型",
    Reroute: "重新路由",
    DO_Info: "发货单信息",
    System_Node: "系统节点",
    Outbound_Node_Name: "实发仓库",
    Error_Reason: "错误原因",
    Sync_WMS_Time: "同步WMS时间",
    Actual_Node_Name: "实际出库仓",
    Outbound_Time: "出库时间",
    Is_COD: "是否COD",
    Check_Logistics: "查看物流",
    Logistics_Info: "物流信息",
    Are_you_sure_want_to_complete_the_DO: "您确定要完成这个发货单?",
    Batch_cancel_all_success: "所有发货单取消成功",
    Batch_cancel_tips:
      "{successSize} 单发货单取消成功, {failSize}单发货单取消失败",
    Back: "Back",
    Batcg_route_selectedRow_empty_tips:
      "请选择路由失败或者配货失败的发货单并尝试重新路由"
  },

  "20200917": {
    Product: {
      channel: "渠道:",
      add_channel: "添加渠道",
      channel_category: "渠道商品分类",
      channel_category_colon: "渠道商品分类:",
      channel_brand_colon: "渠道商品品牌:",
      page_refresh: "切换会导致未保存的内容丢失，确定要继续吗？",
      switch_notice: "渠道商品分类保存后不可更改，确定要继续吗?",
      select_channel: "选择渠道",
      select_category: "选择分类",
      switch: "切换",
      sku_notice: "SKU和属性只能在主渠道下添加",
      disabled_sku: "商品渠道信息尚未保存，无法编辑和发布SKU",
      no_data: "无数据",
      publish: "发布",
      save_publish: "保存并发布商品和SKU",
      save_publish_notice: "确定要保存并发布商品和SKU吗？",
      channelProductCode: "Channel Product Code",
      noCategoty: "请先选择渠道分类"
    },
    Import: {
      channel_info: "渠道信息"
    }
  },
  Family: {
    title: "品类",
    Name: "名称",
    search_info: "输入品类名以搜索",
    create_family: "新建品类",
    edit_family: "编辑品类",
    product_attribute: "商品属性",
    SKU_attribute: "SKU属性",
    family_name: "品类名称",
    page_info: "创建商品品类能帮助你在新建商品时快速的添加属性",
    delete_notice: "你确定要删除吗?",
    items_selected: " 已选"
  },
  DORoutingRules: {
    Reply_to_Review: "回复",
    Reply_to_Review_Notice: "注意! 您的回复将显示在商品详细信息页面上",
    Seller_replied: "卖家已回复",
    Hide_on_Feed: "隐藏评价",
    Show_on_Feed: "展示评价",
    Reply: "回复",
    Rating: "评价",
    Content: "内容",
    Products: "商品",
    Consignee: "收货人",
    Cancel_Orders_Overtime: "取消超时时间",
    Is_Need_Refund_Application: "是否绑定退款申请",
    place_an_order_No_delivery_after_X_hours_cancelled:
      "下单{n}小时未发货, 订单将被自动取消",
    DO_Routing_Rules: "发货单路由规则",
    Create_Routing_Setting: "创建路由配置",
    Edit_Routing_Setting: "修改路由配置",
    Split_Order_Delivery: "是否允许拆单",
    Split_Order_Giveaway: "赠品是否允许拆单",
    Cancel_Out_of_Stock: "部分发货缺货是否取消",
    Partial_Shipment: "部分配货",
    Pickup_Method: "捡货方式",
    By_Online_Stores: "线上店开关",
    By_Area: "发货单路由规则",
    Delivery_order_can_be_routed_to_multiple_warehouse_shipments:
      "配送单是否允许路由到多个仓库发货",
    Delivery_order_contains_gifts: "配送单包含赠品是否允许拆单",
    WMS_partial_delivery: "WMS部分发货，是否取消缺货行",
    Whether_to_allow_WMS_partial_shipment: "是否允许WMS部分发货",
    Back_Order_Reallocation: "配货失败是否自动路由",
    Shipment_By_Channel_Warehou: "是否固定渠道仓发货",
    Shipment_By_Channel_Warehou_tips:
      "当渠道给OMS指定仓库时，必须根据渠道指定的仓库发货",
    Back_Order_Reallocation_tips: "是否允许多个相同的线上店",
    Routing_Out_of_Stock_Split_Order: "是否允许路由缺货拆单",
    Routing_Out_of_Stock_Split_Order_tips:
      "当DO单多行商品时, 订单路由时一些商品行缺货, 这个订单将被自动拆分。 有货所有行将发货,无货行将变更状态为路由失败"
  },
  store: {
    Basic: {
      OK: "了解",
      CreateAdminSuccess: "用户名:{account}初始化密码已发送到您的邮箱:{email}",
      FirstName: "姓",
      LastName: "名",
      AdministratorAccount: "店长账号",
      Email: "邮箱",
      AddAdministratorAccount: "添加店长账号",
      open_status: "开启",
      Online_Store: "店铺",
      Offline_Store: "门店",
      OfflineStoreName: "门店名称",
      OfflineStoreCode: "门店编码",
      OpenStatus: "开启",
      Start_Time: "开始时间",
      End_Time: "结束时间",
      Avaliability: "可用",
      Dou_want_deactivate_store: "您确认要执行关闭操作吗 ?",
      Dou_want_close_store: "您确认要执行关闭操作吗 ?",
      Yes: "是",
      No: "否",
      AddProducts: "添加商品",
      AddTags: "添加标签",
      SelectProducts: "选择商品",
      Cancel: "取消",
      BasicInfo: "基础信息",
      CreateOfflineStore: "创建门店",
      EditOfflineStore: "编辑仓库",
      Address: "地址",
      ManagerInfo: "管理信息",
      PostCode: "邮编",
      Save: "保存",
      StoreCoverPhoto: "门店封面",
      Only_n_files_size_less:
        "限制{count}张类型为jpg/png的图片，且文件大小在{size}以下",
      PleaseEnterDigits: "请输入8-16位数字和字母的组合作为账号",
      OperationSetting: "运营配置",
      Account: "账号",
      Required: "必填项",
      Create_time_at: "创建于: {createTime}",
      StoreCodeIs: "门店编码: {storeCode}",
      OfflineStoreProduct: "门店商品",
      Store_Search_Key_Placeholder: "门店名称"
    },
    Common: {
      WMS_System: "WMS 系统",
      open_status: "开店状态",
      Reset: "重置",
      Action: "操作",
      Create: "创建",
      Edit: "编辑",
      Search: "搜索",
      Cancel: "取消",
      cancel: "取消",
      Continue: "下一步",
      Confirm: "确认",
      Warning: "警告",
      no_empty: "不能为空",
      Next: "下一步",
      Save: "保存",
      please_select: "请选择 ",
      Add: "添加",
      Status: "状态",
      confirm_delete: "你确定要删除吗?",
      create_time: "创建时间",
      return: "退货",
      View: "查看",
      sure: "确认",
      title: "标题",
      country: "国家",
      province: "省",
      city: "市",
      zip_code: "邮编",
      addr_1: "地址1",
      addr_2: "地址2",
      first_name: "姓名",
      last_name: "Last Name",
      mobile_no: "手机",
      e_mail: "邮箱",
      tax_id: "税号",
      bank_name: "银行",
      acc_name: "账号名称",
      acc_no: "账号",
      save_next: "保存 & 下一步",
      car: "车",
      Motocyle: "摩托",
      store_name_or_code: "门店名称或编码",
      reset: "重置",
      save: "保存",
      finish: "完成",
      store_perferences: "门店选项",
      change_vat: "VAT支付",
      are_you_sure: "您确认要执行此操作?",
      actite: "开启",
      reset_pass: "重置密码",
      are_u_sure_to_active_shop_status: "你确定要改变店铺状态?",
      Ok: "确定",
      Longitude: "经度",
      Latitude: "纬度",
      Activate: "启用",
      Inactivate: "停用",
      Active: "启用",
      Inactive: "停用",
      Authorized: "已授权",
      Unauthorized: "未授权",
      Required: "必须",
      More: "更多",
      Email: "邮箱",
      Mobile: "手机",
      Telephone: "电话",
      Choose_Org: "选择组织",
      Region: "地区",
      Is_Authorized: "授权",
      Availability: "启用",
      Start_Date: "开始时间",
      End_Date: "结束时间",
      Create_Time: "创建时间",
      Basic_Info: "基础信息",
      Import: "导入",
      Import_description: "我们建议您在导入之前先下载模版"
    },
    Store: {
      store: "门店",
      manager: "管理",
      Manager_Account: "管理账号",
      location: "地点",
      type_to_search: "请输入门店名称或编码",
      create_new_store: "创建新门店",
      store_info: "门店信息",
      store_name: "门店名称",
      Business_phone: "商务手机号",
      Google_coordinates: "谷歌坐标",
      Store_manager: "门店管理",
      edit_store: "编辑门店",
      Settlement: "结算信息",
      Inactivate: "停用",
      Manage_services: "管理服务",
      Store: "门店",
      Click_to_Collect: "门店自提",
      PickupinStore: "门店自提",
      Seller_Delivery: "商家配送",
      edit_store_services: "修改门店服务",
      External_Store_Code: "外部门店编码",
      Bank_Branch_Name: "银行支行名称"
    },
    EditServices: {
      Store_Operation_Center: "门店运营中心",
      enter_and_submit: "请输入并提交",
      store_code: "请输入门店编码 (按Enter键以获取现有列表):",
      service_type: "请输入服务类型 (以逗号分隔):",
      example: "例如 : 类型A, 类型B, 类型C"
    },
    OnlineStore: {
      Online_Stores: "店铺",
      Online_Stores_Name: "店铺名称",
      Channel: "渠道",
      "Online_Stores_#": "店铺编码",
      Status: "状态",
      Create_Time: "创建时间",
      Create_Online_Stores: "创建店铺",
      Edit_Online_Stores: "编辑",
      Sales_Model: "销售模式",
      Authorization: "授权",
      Start_Authorization: "重新授权",
      Save_Authorization: "保存 & 授权",
      "External_Stores_#": "外部店铺编码",
      Authorization_Status: "授权状态",
      Authorization_Expiration_Time: "授权过期时间",
      Congratulations: "恭喜 !",
      The_authorization_is_successful: "授权成功",
      Back_to_List: "返回列表",
      Authorization_Result: "授权结果",
      Authorization_failed: "授权失败",
      After_xx_seconds_automatically_return_to_the_list:
        "将在<span>{number}</span>秒后自动回到列表页",
      Repeated_authorization: "重复授权, 授权店铺 {name} 已授权, 请检查",
      Please_click_start_authorization_to_authorize: "请点击重新授权，进行授权",
      BliBli_Authorization: "BliBli授权",
      Token: "Token",
      History_Token: "历史Token",
      Expiration_Time: "过期时间"
    }
  },
  exportPage: {
    export: "导出",
    success_export: "导出请求已经成功提交",
    export_notice_title: "导出商品",
    export_submitted: "导出后, 请到导出列表查看导出状态，及下载数据文件。",
    export_all: "你正在请求导出商品",
    export_filter: "你正在请求导出筛选后的商品",
    view_export: "查看导出状态"
  }
};
